var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "face-result" },
    [
      _vm.$isFlag
        ? _c("common-navbar", { attrs: { "is-home-bar": true } })
        : _vm._e(),
      _vm.loading
        ? _c(
            "van-loading",
            {
              staticClass: "jumpClass",
              attrs: {
                size: "40px",
                vertical: "",
                color: "#0094ff",
                "text-size": "17px"
              }
            },
            [_vm._v("正在跳转至支付宝")]
          )
        : _c("div", [
            _vm.isFace === 1
              ? _c("div", { staticClass: "identity-retrieval-four" }, [
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        "亲爱的玩家，您当前的身份证绑定了" +
                          _vm.bindPhoneList.length +
                          "个雷霆账号："
                      )
                    )
                  ]),
                  _c(
                    "ul",
                    [
                      _c("li", [_vm._v("雷霆账号")]),
                      _vm._l(_vm.bindPhoneList, function(item, i) {
                        return _c("li", { key: i }, [_vm._v(_vm._s(item))])
                      })
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "bottom" },
                    [
                      _c(
                        "van-button",
                        {
                          staticClass: "formClass_btn",
                          attrs: {
                            round: "",
                            block: "",
                            plain: "",
                            type: "info",
                            color: "#616edf"
                          },
                          on: { click: _vm.handleWrite }
                        },
                        [_vm._v("重新填写身份信息")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "identity-retrieval-two__errortips" },
                    [_vm._v("该身份证今日查询次数已达到上限，请明日再来")]
                  ),
                  _c("div", { staticClass: "identity-retrieval-two__tips" }, [
                    _c("span", [_vm._v("温馨提示：")]),
                    _c("p", [
                      _vm._v(
                        "1.为了确保账号的安全隐私，系统隐去部分账号信息，请您根据显示的信息自行回忆完整的账号。"
                      )
                    ]),
                    _c("p", [
                      _vm._v("2.若您已记起完整的账号，可以找回您的账号密码。")
                    ])
                  ])
                ])
              : _vm._e(),
            _c(
              "p",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isFace == 0,
                    expression: "isFace == 0"
                  }
                ],
                staticClass: "notice"
              },
              [_vm._v(_vm._s(_vm.noticeMsg))]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isFace == 2,
                    expression: "isFace == 2"
                  }
                ],
                staticClass: "appealResult"
              },
              [
                _c("img", {
                  attrs: {
                    src: require("assets/images/accountCenter/fail@2x.png"),
                    alt: ""
                  }
                }),
                _c("p", [_vm._v("人脸认证失败")]),
                _c(
                  "div",
                  { staticClass: "btn" },
                  [
                    _c(
                      "van-button",
                      {
                        staticClass: "formClass_btn",
                        attrs: {
                          round: "",
                          plain: "",
                          type: "info",
                          color: "#616edf"
                        },
                        on: { click: _vm.handleWrite }
                      },
                      [_vm._v("手动绑定身份找回")]
                    ),
                    _c(
                      "van-button",
                      {
                        staticClass: "formClass_btn",
                        attrs: {
                          round: "",
                          block: "",
                          type: "info",
                          color: "#616edf",
                          disabled: _vm.disabled
                        },
                        on: { click: _vm.faceAgain }
                      },
                      [_vm._v("继续人脸找回")]
                    )
                  ],
                  1
                )
              ]
            )
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }